		$(function() {

			var userAgent = window.navigator.userAgent;
			if(userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)){
				$("body").addClass("safari");
			}
			if(userAgent.match(/Android/i)){
				$("body").addClass("android");
			}
			
			$(".loginlink").on( "click", function() {
				var vm = this;
                $.ajax({
                    type : 'GET',
                    url : '/loginRegister',
                    dataType : "html"
                })
				.then(function (response) {
                    $("#loginRegisterContainer").empty()
					$("#loginRegisterContainer").append(response);


                    $("#header-login").dialog({
                        dialogClass:'headerLogin',
                        autoOpen:false,
                        modal : true,
                        resizable:false,
                        draggable:false,
                        width: 644,
                        minHeight: 503
                    });

                    $("#header-login").dialog("open");

                    $("#loginclose").on( "click", function() {
                        $("#header-login").dialog("close");
                    });
                    $("#signuplink").on( "click", function() {
                        $('img[name=registerCaptchaImg]').attr('src', '/captcha');

                        $(".signup-tab").show();
                        $(".signin-tab").hide();
                    });
                    $("#signinlink").on( "click", function() {
                        $(".signin-tab").show();
                        $(".signup-tab").hide();
                    });
                    
                    if(vm.getAttribute("data-loginType")) {
                    	 $(".signin-tab").hide();
                         $(".signup-tab").show();
                    }else{
                    	 $(".signin-tab").show();
                         $(".signup-tab").hide();
                    }

				});
			});




			$(".dropdown-toggle-user").click(function() {
				$('.user-dropdown').fadeToggle("fast");
				return false;
			});
			$(".selectLang").click(function() {
				$('.countryList').fadeToggle("fast");
				return false;
			});
			$('body, .usertoggle').click(function(event) {
				if (!$(event.target).closest('.countryList').length) {
					$('.countryList').hide();
				};
			});
			$(".usertoggle").click(function() {
				$('.usermenu').css("display", "block");
				return false;
			});
			$('body, .selectLang').click(function(event) {
				if (!$(event.target).closest('.usermenu').length) {
					$('.usermenu').hide();
				};
			});
			$('body').click(function(event) {
				$('.mob-modal').hide();
			});
			
			$(document).click(function(event) { 
			    if(!$(event.target).closest('.user-dropdown').length) {
			        if($('.user-dropdown').is(":visible")) {
			            $('.user-dropdown').hide();
			        }
			    }        
			});

			$('#languageSelection').change(function e() {
				var lang = $(this).val();
				if (lang) {
					$.cookie('siteLocale', lang, {
						expires : 365,
						path : '/'
					});

				}
				reloadPage();
			});

			$('#currencySelection').change(function e() {
				var currency = $(this).val();
				if (currency) {
					$.cookie('currency', currency, {
						expires : 365,
						path : '/'
					});
					
					try {
						var curr = $('input[type=hidden][name=reload_currency]');
						if(curr != null && curr.length > 0)
							$('input[type=hidden][name=reload_currency]').val(currency);
						else{
							var postForm = $("#postForm");
							$('<input>').attr({
								type: 'hidden',
							    name: 'reload_currency',
							    value: currency
							}).appendTo(postForm);
						}

					} catch (e) {
						// TODO: handle exception
					}
				}
				reloadPage();
			});

			var currency = $.cookie('currency');
			if (currency) {
				$("#currencySelection").val(currency);
                $('#currencySign').text(currency);
			}

			var siteLocale = $.cookie('siteLocale');
			if (siteLocale) {
				$('#languageSelection').val(siteLocale);
				var flag = 'flags16 fl-' + siteLocale;
				// var langName = FmtMessage.getMessage("js.locale.name." + siteLocale);
                $("#langFlag").removeClass();
				$("#langFlag").addClass(flag);
				var lang = $('#languageSelection option:selected').text();
                $("#langName").text(lang)

            }

			$("#postData").attr("action", window.location);

			$(".toolTip,.titleTip").tipTip({
				maxWidth : "300px",
				defaultPosition : "top",
				edgeOffset : 2
			});
			$("#showMenu").click(function() {
				$('#nav,.overlay-bg').fadeToggle("fast");
				$('.glyphicon-remove,.glyphicon-menu-hamburger').toggle("fast");
				$('body').toggleClass("open");
				return false;
			});

			$("#showTabletMenu").click(function() {
				$('.tabletMenu').fadeToggle("fast");
				return false;
			});
			
			$('input[readonly]').focus(function(){
			    this.blur();
			});
			
			$(".ui-datepicker-prev,.ui-datepicker-next").click(function() {
				$('input[readonly]').blur();
			});
			$("#live-chat").click(function() {
				try {
					LC_API.open_chat_window();
				} catch (e) {
					alert(e);
					return false;
				}
				return false;
			});
			
			$("#mobile-pop-link").click(function() {
				$('#captchaImg').attr('src', '/captcha');
				$('.mobile-popover').fadeToggle("fast");
				return false;
			});
			$("#mobile-popover-close").click(function() {
				$('.mobile-popover').hide();
				return false;
			});
			$("#close-discount").click(function() {
				$('#discountAlert').hide();
				return false;
			});

            setTimezoneCookie();

            $( ".priceAlertLink" ).click(function() {

                $.ajax({
                    type : 'GET',
                    url : '/priceAlertForm',
                    dataType : "html"
                })
				.then(function (response) {

                    $("#priceAlertContainer").empty()
                    $("#priceAlertContainer").append(response);


                    $( "#priceAlert" ).dialog({
                        autoOpen: false,
                        width : 700,
                        height : 600,
                        modal : true,
                        show: "fade",
                        hide: "fade",
                        dialogClass : 'price-alert',
                        resizable : false,
                        draggable : false
                    });

                    $( "#priceAlert" ).dialog( "open" );
                    if ($("#isResultPage").val() == 'false' || $("#isResultPage").val()== '' ){
                        $("#pa-popupType" ).val("1");
                    }else{
                        $("#pa-popupType" ).val("2");
                    }

				});






            });
		});

		// placeholder fix for IE

		(function($) {
			$.fn.placeholder = function() {
				if (typeof document.createElement("input").placeholder == 'undefined') {
					$('[placeholder]').focus(function() {
						var input = $(this);
						if (input.val() == input.attr('placeholder')) {
							input.val('');
							input.removeClass('placeholder');
						}
					}).blur(
							function() {
								var input = $(this);
								if (input.val() == ''
										|| input.val() == input
												.attr('placeholder')) {
									input.addClass('placeholder');
									input.val(input.attr('placeholder'));
								}
							}).blur().parents('form').submit(function() {
						$(this).find('[placeholder]').each(function() {
							var input = $(this);
							if (input.val() == input.attr('placeholder')) {
								input.val('');
							}
						})
					});
				}
			}
		})(jQuery);

		$.fn.placeholder();

		function reloadPage() {
			window.location.reload();
		}

		function reSubmitPage() {
			openLoaderBox();
			var postForm = $("#postForm");
			postForm.find("input").each(
					function() {
						var name = $(this).attr("name");
						if(name !== undefined && name != null && name.toLowerCase() != "reload_lang"){
							$(this).attr("name",name.replace("reload_", ""));
						}
					});
			postForm.submit();
		}
		
		function closePrivacyBox(){
			$('#dialog').hide("slow");
			setPrivacyValueToCookie("privacyPopup", "closed");
			
		}
		function setPrivacyValueToCookie(name, value) {
				$.cookie(name, value, { expires : 365, path : '/' });
		}

        function setTimezoneCookie(){

            var timezone_cookie = "timezoneoffset";

            // if the timezone cookie not exists create one.
            if (!$.cookie(timezone_cookie)) {

                // check if the browser supports cookie
                var test_cookie = 'test cookie';
                $.cookie(test_cookie, true);

                // browser supports cookie
                if ($.cookie(test_cookie)) {

                    // delete the test cookie
                    $.cookie(test_cookie, null);

                    // create a new cookie
                    $.cookie(timezone_cookie, new Date().getTimezoneOffset());
                }
            }
            // if the current timezone and the one stored in cookie are different
            // then store the new timezone in the cookie and refresh the page.
            else {

                var storedOffset = parseInt($.cookie(timezone_cookie));
                var currentOffset = new Date().getTimezoneOffset();

                // user may have changed the timezone
                if (storedOffset !== currentOffset) {
                    $.cookie(timezone_cookie, new Date().getTimezoneOffset());
                }
            }
        }